<template>
  <el-dialog title="新增团队" :visible.sync="visible" width="800px" class="my-dialog-template" :close-on-click-modal="false" append-to-body>
    <modifyLowerMechanForm v-if="visible" ref="modifyLowerMechanForm" @close="visible = false"></modifyLowerMechanForm>
  </el-dialog>
</template>
<script>
import modifyLowerMechanForm from './modifyLowerMechanForm.vue'
export default {
  components: { modifyLowerMechanForm },
  data: () => ({
    radio: '1',
    visible: false,
    userinfo: {}, // 当前登录账号
  }),
  created() {
    // 当前账号数据
    this.userinfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    open(data = null) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.modifyLowerMechanForm.open(data)
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template {
  .top-box {
    margin-bottom: 30px;
    .label {
      width: 110px;
      font-weight: bold;
      font-size: 14px;
      color: #333333;
      padding-right: 20px;
      display: inline-block;
      text-align: right;
    }
  }
}
</style>
